import { LearningBudgetService } from '@/services/learning-budget';
import { ApiReactMutationOptions } from '@/types/api';
import {
  ILearningBudgetCreatePayload,
  ILearningBudgetSetup,
} from '@/types/learning-budget';
import { useMutation } from '@tanstack/react-query';

export function useLearningBudgetSetupMutation(
  options?: ApiReactMutationOptions<
    ILearningBudgetSetup,
    ILearningBudgetCreatePayload
  >,
) {
  return useMutation({
    mutationKey: [LearningBudgetService.SETUP_PATH],
    mutationFn: async payload => {
      const response =
        await LearningBudgetService.createLearningBudgetSetup(payload);
      return response.data;
    },
    ...options,
  });
}
